// filepath: /Users/hayashimie/git/wako-coffee/src/ts/namespace/cardFlip.ts

// アニメーション設定の定数
const ANIMATION_CONFIG = {
  flipInterval: 800,
  cycleDelay: 1500,
  directionChangeInterval: 10,
} as const;

// カードの型定義
type Card = {
  element: HTMLElement;
  inner: HTMLElement;
  front: HTMLElement | null;
  back: HTMLElement | null;
};

/**
 * メインビジュアルのカードフリップアニメーション
 * カード1から4まで順番に表裏を反転させる
 * 全てのカードが反転したら、再び1から順番に反転させて表裏を交互に切り替える
 * 10サイクルごとに回転方向を交互に切り替える（右回り→左回り→右回り）
 */
function cardFlip(): void {
  const cardElements = document.querySelectorAll<HTMLElement>(".p-mv__product");
  if (cardElements.length === 0) return;

  // カードの初期化と型安全な配列の作成
  const cards: Card[] = Array.from(cardElements).map((element) => {
    const inner = element.querySelector<HTMLElement>(".p-mv__product-inner");
    if (!inner) throw new Error("Inner element not found");

    const front = inner.querySelector<HTMLElement>(".p-mv__product-front");
    const back = inner.querySelector<HTMLElement>(".p-mv__product-back");

    return { element, inner, front, back };
  });

  let currentIndex = 0;
  let cycleCount = 0;
  const cardRotations = new Map<HTMLElement, number>();

  // 初期化：すべてのカードの回転角度を0度に設定
  cards.forEach(({ element, inner }) => {
    cardRotations.set(element, 0);
    inner.style.transform = "rotateY(0deg)";
  });

  // カードを順番に処理する関数
  const processCard = (index: number): void => {
    if (index >= cards.length) {
      cycleCount++;
      setTimeout(() => {
        currentIndex = 0;
        processCard(currentIndex);
      }, ANIMATION_CONFIG.cycleDelay);
      return;
    }

    const { element, inner } = cards[index];
    const currentRotation = cardRotations.get(element) ?? 0;
    const isClockwise = Math.floor(cycleCount / ANIMATION_CONFIG.directionChangeInterval) % 2 === 0;
    const rotationChange = isClockwise ? 180 : -180;
    const newRotation = currentRotation + rotationChange;

    inner.style.transform = `rotateY(${newRotation}deg)`;
    cardRotations.set(element, newRotation);

    setTimeout(() => {
      currentIndex++;
      processCard(currentIndex);
    }, ANIMATION_CONFIG.flipInterval);
  };

  // アニメーション開始
  try {
    processCard(currentIndex);
  } catch (error) {
    console.error("Card flip animation error:", error);
  }
}

export { cardFlip };
